import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RestProvider {
  projects(companyId: string) {
    throw new Error("Method not implemented.");
  }
  // static PREFIX = 'http://192.168.1.114/time-back-end/index.php/time';
  // static PREFIX = 'https://time.susano-tech.mn/backend/index.php/time';
  static PREFIX = '/backend/index.php/time';


  constructor(public http: HttpClient) {
  }
  public login(loginId: string, password: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/login/', {email: encodeURIComponent(loginId), password: password});
  }
  public register(name: string, email: string, password: string, companyId: string, jobId: string, image: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/register/', {name: encodeURIComponent(name), email: email, password: password, companyId: companyId, jobId:jobId, image: image});
  }
  public companys(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCompanys/', {});
  }
  public companyDetail(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCompanyId/', {companyId: companyId});
  }
  public jobs(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getJobs/', {companyId: companyId});
  }
  public setUserSick(userId: string, startDate: string, endDate: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setUserSick/', {userId: userId, startDate: startDate, endDate: endDate});
  }
  public Dates(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getDates/', {companyId: companyId});
  }
  public TimeCard(userId: string, date: string, companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getTimeCard/', {userId: userId, date: date, companyId: companyId });
  }
  public timeBegin(userId: string, date: any, type: string, irsenType: string, irsenDesc: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTimeBegin/', {userId: userId, date: date, type: type, irsenType: irsenType, irsenDesc: irsenDesc });
  }
  public timeEnd(userId: string, date: string, type: string, companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTimeEnd/', {userId: userId, date: date, type: type, companyId: companyId });
  }
  public huselt(userId: string, sdate: string, edate: string, type: string, ttype: string, time: string, desc: string, stime: any, tasks: any, obtime: any, salary: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setHuselt/', {userId: userId, sdate: sdate, edate: edate, ttype:ttype, type: type, time: time, desc: desc, stime: stime, tasks: tasks, obtime: obtime, salary: salary });
  }
  public Batalgaajuulalt(userId: string, date: string, allday: string, cday: string, uday: string, alltime: string, utime: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTimeVerify/', {userId: userId, date: date, allday: allday, cday: cday, uday: uday, alltime: alltime, utime: utime });
  }
  public SetWorks(companyId: string, leaderUserId: string, title: string, beginDay: string, endDay: string, usageTime: string, spendTime: string, spendProcess: string, createdUserId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setWorks/', {companyId: companyId, leaderUserId: leaderUserId, title: title, beginDay: beginDay, endDay: endDay, usageTime: usageTime, spendTime: spendTime, spendProcess: spendProcess, createdUserId: createdUserId });
  }
  public GetWorks(companyId: string, beginDate: string, endDate: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getWorks/', {companyId: companyId, beginDate: beginDate, endDate: endDate});
  }
  public EditWorks(workId: string, companyId: string, leaderUserId: string, title: string, beginDay: string, endDay: string, usageTime: string, spendTime: string, spendProcess: string, createdUserId): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/editWorks/', {workId: workId, companyId: companyId, leaderUserId: leaderUserId, title: title, beginDay: beginDay, endDay: endDay, usageTime: usageTime, spendTime: spendTime, spendProcess: spendProcess, createdUserId: createdUserId});
  }
  public GetProjects(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getProjects/', {companyId: companyId});
  }
  public GetUserTasks(userId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getUserTasks/', {userId: userId});
  }
  public GetAllTasks(companyId: string, beginDate: string, endDate: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getAllTasks/', {companyId: companyId, beginDate: beginDate, endDate:endDate });
  }
  public GetTasks(workId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getTasks/', {workId: workId });
  }
  public addTimeTable(userTaskId: string, spendTime: string, userId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTimetables/', {userTaskId: userTaskId, spendTime: spendTime, userId: userId });
  }
  public addTimeTableRe(userTaskId: string, spendTime: string, userId: string, timetableId: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTimetablesLast/', {userTaskId: userTaskId, spendTime: spendTime, userId: userId, timetableId: timetableId });
  }
  public registerUpdate(userId: string, name: string, password: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/registerUpdate/', {userId: userId, name: name, password: password});
  }
  public Image(userId: string, image: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/do_upload/', {userId: userId, image: image});
  }
  public GetRequest(userId: string, date: string, type: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getHuselt/', {userId: userId, date: date, type: type});
  }
  public timeRequestAgree(userId: string, tid: string, type: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/timeHuseltAgree/', {userId: userId, tid: tid, type: type});
  }
  public userSetRequest(tid: string, sdate: string, edate: string, ttype: string, type: string, time: string, desc: string, salary: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setHuseltAgian/', {tid: tid, sdate: sdate, edate: edate, ttype: ttype, type: type, time: time, desc: desc, salary: salary});
  }
  public deleteRequest(tid: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/deleteHuselt/', {tid: tid});
  }
  public updateRequest(tid: string, desc: any, type: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/updateHuselt/', {tid: tid, desc: desc, type: type});
  }
  public addProject(workId: string, companyId: string, leaderUserId: string, title: string, beginDay: string, endDay: string, usageTime: string, spendTime: string, spendProcess: string, customerId: string, projectMembersIds: string, createdUserId: string, isEnd: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setWorks/', {workId: workId, companyId:companyId, leaderUserId:leaderUserId, title: title, beginDay:beginDay, endDay:endDay, usageTime:usageTime, spendTime: spendTime, spendProcess: spendProcess, customerId:customerId, projectMembersIds: projectMembersIds, createdUserId: createdUserId, isEnd: isEnd});
  }
  public addTasks(taskId: string, workId: string, title: string, beginDay: string, endDay: string, usageTime: string, createdUserId: string, isEnd: string, taskMembersIds: string ): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTasks/', {taskId: taskId, workId:workId, title:title, beginDay:beginDay, endDay:endDay, usageTime:usageTime, createdUserId:createdUserId, isEnd: isEnd, taskMembersIds: taskMembersIds});
  }
  public GetCustomers(): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCustomers/', {});
  }
  public setCustomers(id: string, customerName: string, customer_zName: string, formatBeginDay: string, customer_phone_number: string, email: string, address: string, desc: string , isEnd:string, queryType: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setCustomers/', {id:id, customerName:customerName, customer_zName:customer_zName, formatBeginDay:formatBeginDay, customer_phone_number:customer_phone_number, email: email, address:address, desc:desc, isEnd: isEnd, queryType: queryType});
  }
  public GetCmbUser(companyId:string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCmbUser/', {companyId:companyId});
  }
  public GetUsersTimes(companyId: string, date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getUsersTimes/', {companyId: companyId, date: date });
  }
  public GetUsersTimesByDate(companyId: string, date: string, sDate: string, fDate: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getUsersTimesByDate/', {companyId: companyId, date: date, sDate: sDate, fDate:fDate});
  }
  public GetUsers(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getUsers/', {companyId: companyId});
  }
  public AdminAgree(userId: string, date: string, allday: string, uday: string, cday: string, alltime: string, utime:string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/setTimeVerifyAdmin/', {userId: userId, date:date, allday: allday, uday: uday, cday: cday, alltime: alltime, utime:utime});
  }
  public GetOgnoo(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getOgnoos/', {companyId: companyId});
  }
  public addOgnoo(year: string, month: string, val: string, companyId: string, bdate: string, edate: string, interval: string ): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/addOgnoo/', {year: year, month: month, val: val, companyId: companyId, bdate: bdate, edate: edate, interval: interval});
  }
  public editOgnoo(year: string, month: string, val: string, ognooId: string, bdate: string, edate: string, interval: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/editOgnoo/', {year: year, month: month, val: val, ognooId: ognooId, bdate: bdate, edate: edate, interval: interval});
  }
  public deleteOgnoo(ognooId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/deleteOgnoo/', {ognooId: ognooId});
  }
  public getCalendars(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getCalendars/', {companyId: companyId});
  }
  public getStatuses(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getStatuses/', {companyId: companyId});
  }
  public addCalendar(userId: string, val: string, companyId: string, date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/addCalendar/', {userId: userId, val: val, companyId: companyId, date: date});
  }
  public editCalendar(userId: string, val: string, calendarId: string, date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/editCalendar/', {userId: userId, val: val, calendarId: calendarId, date: date});
  }
  public deleteCalendar(calendarId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/deleteCalendar/', {calendarId: calendarId});
  }
  public editUser(userId: string, name: string, jobId: string, type: string, status: string, date: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/editUser/', {userId: userId, name: name, jobId: jobId, type: type, status: status, date: date});
  }
  public deleteUser(userId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/deleteUser/', {userId: userId});
  }
  public editUserVerify(userId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/editUserVerify/', {userId: userId});
  }
  public getTypes(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getTypes/', {companyId: companyId});
  }
  public getPosts(companyId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getPosts/', {companyId: companyId});
  }
  public addPost(userId: string, name: string, desc: string, companyId: string, url:string, image: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/addPost/', {userId: userId, name: name, desc: desc, companyId: companyId, url: url, image: image});
  }
  public editPost(userId: string, name: string, desc: string, postId: string, url:string, image: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/editPost/', {userId: userId, name: name, desc: desc, postId: postId, url: url, image: image});
  }
  public deletePost(postId: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/deletePost/', {postId: postId});
  }
  public getAmraltCount(sdate: any, edate: any): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/getAmraltCount/', {sdate: sdate, edate: edate});
  }
  public monthTimeAgree(userId: string, companyId: string, date: string, stime: string, etime: string): Observable<any> {
    return this.http.post(RestProvider.PREFIX + '/monthTimeAgree/', {userId: userId, companyId: companyId, date: date, stime: stime, etime: etime});
  }  
  public getNotifUsersDate(): Observable<any> {
    return this.http.get(RestProvider.PREFIX + '/getNotifUsersDate/');
  }
}



// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts